// GENERADO por scripts/build-i18n.cjs desde package.json — NO editar a mano.
export const APP_VERSION = '1.1.1';

/**
 * Huella del contenido de es.json + en.json. Se usa como parametro de
 * cache en la URL de los diccionarios (ver main.ts). Cambia SOLO cuando
 * cambian las traducciones.
 */
export const I18N_VERSION = '9760a1f680';
